import icon from "./rejected.svg";
const NewRejectedIcon = () => {
  return (
    <img
      src={icon}
      style={{
        width: "15px",
        height: "15px",
      }}
      className="ic d-flex align-items-center justify-content-center"
    />
  );
};

export default NewRejectedIcon;
